export default __webpack_public_path__ + "static/element-swirl-2-f90b5404f320d4cdca85187982f42247.svg";